export default __webpack_public_path__ + "static/media/smallWhiteLogoBelobank.3c756ba6.svg";